import { DraftEntityTypeCode } from '../aps-mgmt';
import { ApsFeatureAction, ApsFeatureObject, ApsPlanReport, PlanExportAction, PlanSchemaActions, PlanSchemaObjects } from './permission-service.types';

const fullAccessAction = { id: '*', name: 'Полный доступ' };
const viewAction = { id: 'view', name: 'Просмотр' };

const crudActions = [
    viewAction,
    { id: 'create', name: 'Создание' },
    { id: 'update', name: 'Редактирование' },
    { id: 'delete', name: 'Удаление' },
];

export const defaultFeaturesTree = {
    id: 'all', name: 'Все',
    children: [
        { id: '*', name: 'Полный доступ', actions: [fullAccessAction] },
    ],
}

export const apsAppFeaturesTree = {
    ...defaultFeaturesTree,
    children: [
        ...defaultFeaturesTree.children,
        {
            id: ApsFeatureObject.Plans, name: 'Планы',
            actions: [
                fullAccessAction,
                { id: ApsFeatureAction.ListAll, name: 'Список всех планов' },
                { id: ApsFeatureAction.ListPublished, name: 'Опубликованный план' },
                { id: ApsFeatureAction.CreatePlan, name: 'Создание плана' },
                { id: ApsFeatureAction.PublishPlan, name: 'Публикация плана' },
                { id: ApsFeatureAction.Delete, name: 'Удаление плана' },
                { id: ApsFeatureAction.WorkflowMgmt, name: 'Изменение статуса' },
            ],
        },
        { id: ApsFeatureObject.ProductionInventory, name: 'Журнал состояний производства', actions: [fullAccessAction] },
        { id: ApsFeatureObject.ServerMonitor, name: 'Монитор сервера', actions: [fullAccessAction] },
        { id: ApsFeatureObject.Forecasts, name: 'Прогнозы', actions: [fullAccessAction] },
        { id: ApsFeatureObject.Services, name: 'Сервисы', actions: [fullAccessAction] },
        { id: ApsFeatureObject.Integrations, name: 'Интеграции', actions: [fullAccessAction] },
        { id: ApsFeatureObject.LossInfo, name: 'Анализ потерь', actions: [fullAccessAction] },
    ],
}

export const apsPlanFeaturesTree = {
    ...defaultFeaturesTree,
    children: [
        ...defaultFeaturesTree.children,
        {
            id: PlanSchemaObjects.Root, name: 'Управление планом',
            actions: [
                { id: PlanSchemaActions.Summary, name: 'Просмотр сводки' },
                { id: PlanSchemaActions.OpenExcel, name: 'Работа с планом в Excel' },
                { id: PlanSchemaActions.Validate, name: 'Проверка данных' },
                { id: PlanSchemaActions.CalculateVersion, name: 'Расчет версии' },
                { id: PlanSchemaActions.Sync, name: 'Синхронизация данных' },
                { id: PlanSchemaActions.Import, name: 'Импорт данных' },
                { id: PlanSchemaActions.Export, name: 'Экспорт данных' },
            ],
        },
        {
            id: PlanSchemaObjects.Orders, name: 'Заказы',
            children: [
                { id: DraftEntityTypeCode.Order, name: 'Клиентские заказы', actions: crudActions },
                { id: DraftEntityTypeCode.ProductionOrders, name: 'Производственные заказы', actions: crudActions },
            ],
        },
        {
            id: PlanSchemaObjects.Input, name: 'Входные данные',
            children: [
                { id: DraftEntityTypeCode.Materials, name: 'Номенклатура', actions: crudActions },
                { id: DraftEntityTypeCode.Technologies, name: 'Технология', actions: crudActions },
                { id: DraftEntityTypeCode.Warehouse, name: 'Места хранения', actions: crudActions },
                { id: DraftEntityTypeCode.Workplaces, name: 'Рабочие места', actions: crudActions },
                { id: DraftEntityTypeCode.Calendar, name: 'Графики работы', actions: crudActions },
                { id: DraftEntityTypeCode.BusinessCalendar, name: 'Графики недоступности', actions: crudActions },
                { id: DraftEntityTypeCode.DeliveryPlan, name: 'План поставки', actions: crudActions },
                { id: DraftEntityTypeCode.Staff, name: 'Персонал', actions: crudActions },
                { id: DraftEntityTypeCode.CalculationSettings, name: 'Параметры расчета', actions: crudActions },
            ],
        },
        {
            id: PlanSchemaObjects.LeftOver, name: 'Остатки',
            children: [
                { id: DraftEntityTypeCode.Wip, name: 'Незавершённое производство', actions: crudActions },
                { id: DraftEntityTypeCode.EndProducts, name: 'Готовые материалы', actions: crudActions },
            ],
        },
        {
            id: DraftEntityTypeCode.Directive, name: 'Директивы',
            children: [
                // Рабочие места
                { id: DraftEntityTypeCode.WorkModeDirective, name: 'Управление режимом работы рабочих мест', actions: crudActions },
                { id: DraftEntityTypeCode.WorkplaceOperationBindDirective, name: 'Привязка рабочего места и операции', actions: crudActions },
                { id: DraftEntityTypeCode.ConsistentOperations, name: 'Выполнение следующей операции на том же рабочем месте', actions: crudActions },
                { id: DraftEntityTypeCode.WorkplaceRestrictions, name: 'Особые ограничения рабочих мест', actions: crudActions },

                // Персонал
                { id: DraftEntityTypeCode.StaffWorkModeDirective, name: 'Управление режимом работы персонала', actions: crudActions },

                // Технология
                { id: DraftEntityTypeCode.AdjustmentControlDirective, name: 'Время наладки для операций', actions: crudActions },
                { id: DraftEntityTypeCode.WorkplaceAdjustmentDirective, name: 'Время наладки для групп оборудования', actions: crudActions },
                { id: DraftEntityTypeCode.OperationBreakDirective, name: 'Управление прерываниями операций', actions: crudActions },
                { id: DraftEntityTypeCode.AltRoute, name: 'Альтернативный ВИМ', actions: crudActions },
                { id: DraftEntityTypeCode.WorkplacePerformanceDirective, name: 'Производительность непрерывных операций', actions: crudActions },
                { id: DraftEntityTypeCode.BasketOperations, name: 'Садочные операции', actions: crudActions },
                { id: DraftEntityTypeCode.PercentExecutionOperationsDirective, name: 'Процент выполнения операции', actions: crudActions },
                { id: DraftEntityTypeCode.KitOperationsDirective, name: 'Комплектные операции', actions: crudActions },

                // Ресурсы
                { id: DraftEntityTypeCode.AltMaterials, name: 'Альтернативные материалы', actions: crudActions },
                { id: DraftEntityTypeCode.MaterialMeasureUnits, name: 'Материалы с двойными единицами измерения', actions: crudActions },

                // Ограничения
                { id: DraftEntityTypeCode.BlackBoxDirective, name: 'Чёрный ящик', actions: crudActions },
                { id: DraftEntityTypeCode.BatchSize, name: 'Ограничение размера партии изготовления', actions: crudActions },
                { id: DraftEntityTypeCode.MaterialMin, name: 'Минимальная партия потребления материалов', actions: crudActions },



                // Матрица
                { id: DraftEntityTypeCode.Matrix, name: 'Матрица перемещений', actions: crudActions },
                { id: DraftEntityTypeCode.TransitionGroup, name: 'Группы перемещений', actions: crudActions },


                // Оптимизационные настройки
                { id: DraftEntityTypeCode.Weight, name: 'Веса оптимизации', actions: crudActions },
                { id: DraftEntityTypeCode.Strategies, name: 'Стратегии оптимизации', actions: crudActions },
                { id: DraftEntityTypeCode.StrategyParams, name: 'Параметры стратегии оптимизации', actions: crudActions },
                { id: DraftEntityTypeCode.Campaign, name: 'Размеры кампаний', actions: crudActions },
                { id: DraftEntityTypeCode.StrategyWorkplaceParams, name: 'Параметры стратегий для рабочих мест', actions: crudActions },
            ],
        },
        {
            id: PlanSchemaObjects.Analytics, name: 'Аналитика и отчёты',
            actions: [
                // Производственные работы
                { id: ApsPlanReport.GanttChart, name: 'График Ганта' },
                { id: ApsPlanReport.EquipmentLoading, name: 'Загрузка оборудования' },
                { id: ApsPlanReport.ProductRelease, name: 'Выпуск материалов' },
                { id: ApsPlanReport.UncompletedDetail, name: 'Незавершённое производство' },
                { id: ApsPlanReport.LayingTime, name: 'Время пролёживания' },
                { id: ApsPlanReport.LeadTime, name: 'Время выполнения' },
                { id: ApsPlanReport.ConveyorLine, name: 'Конвейерная линия' },
                { id: ApsPlanReport.WorkScheduleByWorkshop, name: 'График работ по участку' },
                { id: ApsPlanReport.EquipmentWorksPage, name: 'График работы оборудования' },

                // Ресурсы
                { id: ApsPlanReport.PurchasedMaterialsConsumptionByDay, name: 'Расход материалов (на склад/покупных) по дням' },
                { id: ApsPlanReport.PurchasedMaterialsConsumptionByBatches, name: 'Расход материалов (на склад/покупных) по партиям' },
                { id: ApsPlanReport.PurchasedMaterialsNeeded, name: 'Потребность в материалах (на склад/покупных)' },
                { id: ApsPlanReport.StaffWorkload, name: 'Загрузка персонала' },


                //Служебные
                { id: ApsPlanReport.InputDataComparison, name: 'Сравнение входных данных' },
                { id: ApsPlanReport.DirectivesImpact, name: 'Влияние директив' },
                { id: ApsPlanReport.PlanCalculationResultsComparison, name: 'Сравнение результатов расчёта плана' },
                { id: ApsPlanReport.DeviationFromFirstPlanVersion, name: 'Отклонение от первой версии плана' },
                { id: ApsPlanReport.DiagnosticReport, name: 'Диагностический отчёт' },

                //Прогнозы
                { id: ApsPlanReport.IterativeCalculation, name: 'Итерационный расчёт' },
                { id: ApsPlanReport.WhatIfAnalysis, name: 'Анализ "что-если"' },
                { id: ApsPlanReport.GeneticAlgorithm, name: 'Подбор параметров' },
                { id: ApsPlanReport.AllForecastsAlgorithm, name: 'Все прогнозы' },


                // Устьаревшие?
                { id: ApsPlanReport.EmploymentJobs, name: 'Занятость рабочих мест' },
            ],
        },
        {
            id: PlanSchemaObjects.Export, name: 'Экспорт',
            actions: [
                { id: PlanExportAction.ExportData, name: 'Экспорт данных' },
                { id: PlanExportAction.ExportingTasks, name: 'Экспорт операций в Excel' },
                { id: PlanExportAction.ExportingTasksJson, name: 'Экспорт операций в JSON' },
                { id: PlanExportAction.ExportingShiftTasksPdf, name: 'Экспорт сменных заданий для сотрудников в PDF' },
                { id: ApsPlanReport.BatchAndAdjustmentAnalytics, name: 'Аналитика по партиями и переналадкам' },
            ],
        },
    ],
}